import { ApplyForm } from "@/components/apply/ApplyForm";
import { MurtadaAcademyLandingShell } from "@/components/public/MurtadaAcademyLandingShell";
import type { AcademyLandingContent } from "@/content/landing";

interface MurtadaAcademyLandingProps {
  brandName: string;
  logoUrl: string | null;
  parentOrg: string | null;
  content: AcademyLandingContent;
}

export function MurtadaAcademyLanding({
  brandName,
  logoUrl,
  parentOrg,
  content,
}: MurtadaAcademyLandingProps) {
  return (
    <MurtadaAcademyLandingShell
      brandName={brandName}
      logoUrl={logoUrl}
      parentOrg={parentOrg}
      content={content}
      applicationForm={
        <ApplyForm
          applicantRoleLabel="I am applying as"
          contactEmail="info@murtadaacademy.org"
          editorialSections
          notePlaceholder="Student age, school year, prior study, scheduling, or questions…"
          phoneHint={null}
          phoneRequired
          showProgram={false}
          submitLabel="Submit application"
          submissionNoun="application"
          successHeading="Application received."
          successLead="A director will review your application and reach out within a few days, usually by email, with placement and schedule details."
        />
      }
    />
  );
}
